import Link from '@components/primitives/Link'
import { Text } from '@components/primitives/Text'
import type { ConjuredArticleCitations } from '@modules/conjuredArticles/helpers/getCitationsforConjuredArticle'
export default function ArticleCitations({
  citations,
}: {
  citations: ConjuredArticleCitations
}) {
  if (!citations || citations.length === 0) {
    return <></>
  }

  const citationsElements = citations
    .filter((citation) => citation)
    .map((citation, index) => {
      if (!citation) {
        return <></>
      }

      const { authors, journal, publisher, title, url, year } = citation

      return (
        <li className='flex flex-wrap py-2' key={index}>
          <Text className='whitespace-pre-wrap' styleName='p-small'>
            {`${authors}. (${year}). ${title}. ${journal}.`} <i>{publisher}.</i>
          </Text>
          <Link className='flex underline' href={url} newTab={true}>
            <Text styleName='p-small'>{url}</Text>
          </Link>
        </li>
      )
    })

  return (
    <section id='article-citations'>
      <Text element='h2' styleName='h3' value='Refrences' />
      <ul className='flex flex-wrap'>{citationsElements}</ul>
    </section>
  )
}
